import { render, staticRenderFns } from "./app-page.vue?vue&type=template&id=619f11de"
import script from "./app-page.vue?vue&type=script&lang=js"
export * from "./app-page.vue?vue&type=script&lang=js"
import style0 from "./app-page.vue?vue&type=style&index=0&id=619f11de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports